import { fetchShipmentLogs, changePage } from '#action/shipment/log';
import {
  ProjectsFilterOptionService,
  ShipmentFilterOptionService,
  UserFilterOptionService,
  ActionTypeFilterOptionService
} from '#service/autocomplete-service/service';
import { uuidv4 } from '#helper';
import { shipmentEventType } from '#type';

const projectSelect = {
  type: 'SelectWithCounter',
  name: 'project',
  label: 'Project',
  relatedTo: 'shipment-log',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const shipmentSelect = {
  type: 'SelectWithCounter',
  name: 'shipment',
  label: 'Shipment',
  relatedTo: 'shipment-log',
  id: uuidv4(),
  fetchOptionsService: ShipmentFilterOptionService,
  searchFields: ['label']
};

const filterUserComponent = {
  type: 'SelectWithCounter',
  name: 'user',
  label: 'Actor',
  relatedTo: 'shipment-log',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const actionTypeSelect = {
  type: 'SelectWithCounter',
  name: 'event',
  label: 'Action',
  relatedTo: 'shipment-log',
  id: uuidv4(),
  fetchOptionsService: ActionTypeFilterOptionService,
  optionServiceConfig: { eventTypes: shipmentEventType },
  searchFields: ['label']
};

const filterConfig = {
  disableSync: true,
  customActions: {
    fetchFilterData: fetchShipmentLogs,
    changePage
  },
  dateRangeComponent: true,
  components: [projectSelect, shipmentSelect, filterUserComponent, actionTypeSelect]
};

export default filterConfig;
